/*
 *   File : footer.js
 *   Author : https://evoqins.com
 *   Description : Footer component
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React from 'react';

const Footer = (props) => {
    return (
        <div className={`${props.type === 1 ? "padding-52px-lr" : ""} e-bg-vodka padding-52px-tb`}>
            <div className={props.type === 2 ? 'container' : ''}>
                <p className='mb-0 e-text-chinese-black e-primary-font e-font-12 e-font-weight-400 line-height-20px'>
                    {new Date().getFullYear()} © Rayi All Rights Reserved
                </p>
            </div>
        </div>
    )
}

export default Footer;
